import { getApiClient } from 'adapter/out/client/apiClient';
import { Automation } from 'domain/entity/automation';
import { CreateOrPreviewAutomationCriteria } from 'use-case/automation/create/createAutomationCriteria';

const createAutomationApiClient = getApiClient(
    () => `dashboards/automations`,
    Automation,
    (clientCriteria: CreateOrPreviewAutomationCriteria) => ({
        method: 'POST',
        body: JSON.stringify(parseCreateAutomationCriteria(clientCriteria)),
        headers: { 'Content-Type': 'application/json' },
    })
);

export const parseCreateAutomationCriteria = (criteria: CreateOrPreviewAutomationCriteria) => ({
    template_dashboard_id: criteria.templateDashboardId,
    language: criteria.language,
    location_ids: criteria.locationIds,
    location_tags: criteria.locationTags.join(","),
    start: criteria.start,
    end: criteria.end,
    periodicity: criteria.periodicity,
    delay_days: criteria.delayDays,
    reporting_visibility: {
        scope: criteria.reportingVisibility.scope,
        user_ids: criteria.reportingVisibility.userIds,
    },
});

export default createAutomationApiClient;
